import { daysBetween, todayIso } from '../../shared/data/common';

// Cabs, prices and policies come live from /api/transfers. Popular routes are searched by place
// name; the results page looks each name up, so no coordinates are kept here.
export const popularTransfers = [
  { journey: 'airport', pickup: 'Delhi Airport', drop: 'Connaught Place' },
  { journey: 'airport', pickup: 'Mumbai Airport', drop: 'Bandra West' },
  { journey: 'airport', pickup: 'Bengaluru Airport', drop: 'MG Road Bengaluru' },
  { journey: 'airport', pickup: 'Goa Airport', drop: 'Calangute' },
  { journey: 'outstation', pickup: 'New Delhi', drop: 'Agra' },
  { journey: 'outstation', pickup: 'Mumbai', drop: 'Pune' },
];

/** The kinds of cab suppliers usually offer, for the landing page. */
export const rideTypes = [
  { name: 'Sedan', example: 'Toyota Etios or similar', seats: 3 },
  { name: 'SUV', example: 'Ertiga, Innova or similar', seats: 6 },
  { name: 'Executive', example: 'Innova Crysta or similar', seats: 6 },
  { name: 'Luxury', example: 'Mercedes E-Class or similar', seats: 3 },
];

/**
 * "Free cancellation up to 24 hours before pickup" from the supplier's rules, or null if there is
 * no free cancellation. Rules are sorted most hours first.
 */
export function freeCancellation(rules = []) {
  const free = rules.filter((r) => r.refundPercentage >= 100).sort((a, b) => a.minHoursBefore - b.minHoursBefore)[0];
  if (!free) return null;
  return free.minHoursBefore > 0 ? `Free cancellation up to ${free.minHoursBefore} hours before pickup` : 'Free cancellation until pickup';
}

/** One line per cancellation rule, e.g. "24+ hours before pickup: full refund". Rules are sorted most hours first. */
export function cancellationLines(rules = []) {
  return rules.map((r, i) => {
    const above = rules[i - 1]?.minHoursBefore;
    const when = r.minHoursBefore > 0
      ? (above ? `${r.minHoursBefore}–${above} hours before pickup` : `${r.minHoursBefore}+ hours before pickup`)
      : (above ? `Less than ${above} hours before pickup` : 'Any time before pickup');
    const refund = r.refundPercentage >= 100 ? 'full refund' : r.refundPercentage > 0 ? `${r.refundPercentage}% refund` : 'no refund';
    return `${when}: ${refund}`;
  });
}

/** Refund estimate for demo bookings saved before live transfers; live cabs are quoted by the API. */
export function transferRefund(booking) {
  const days = daysBetween(todayIso(), booking.travelDate);
  if (days >= 1) return { amount: booking.fare.total, note: 'Free cancellation up to 24 hours before pickup.' };
  return { amount: 0, note: 'Within 24 hours of pickup — non-refundable.' };
}
